import React, { useState, useEffect } from 'react';
import icons from '../../utils/icons.json';
import { useDispatch, useSelector } from 'react-redux';
import { imgCheck } from '../../utils/fn';
import { addCartItems, removeCartItem } from '../../store/cartItems';
import { useNavigate } from 'react-router-dom';
// import img from '../../assets/cart2.png';
import img from '../../assets/product-placeholder.png';
import { setAlert } from '../../store/alert';
import { addFavorite, removeFavorite } from '../../store/favorites';
import { motion } from 'framer-motion';
import { capitalize } from '../../utils/functions';
import { IconButton } from '@mui/material';
import { Check, CheckCircle, Favorite, FavoriteBorder, ShoppingBasketOutlined } from '@mui/icons-material';

function Product({ data, showquantity }) {
    const webSettings = useSelector((state) => state.webSettings.data);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const pathname = location?.pathname

    const cartItems = useSelector((state) => state.cartItems.data);
    const favorites = useSelector((state) => state.favorites.data);

    const [isCartItem, setIsCartItem] = useState(false);
    const [isFavorite, setIsFavorite] = useState(false);
    const [thumbnail, setThumbnail] = useState(null);



    useEffect(() => {
        Array.isArray(data.src) && imgCheck(data.src[0], img).then((src) => setThumbnail(src));
    }, [data]);

    useEffect(() => {
        //setToStore(constants.CART_ITEMS, cartItems);
        let found = false;
        cartItems.forEach((item) => {
            if (item.item_code === data.item_code) {
                found = true;
            }
        });
        setIsCartItem(found);
    }, [cartItems]);

    useEffect(() => {
        let found = false;
        favorites.forEach((item) => {
            if (item.item_code === data.item_code) {
                found = true;
            }
        });
        setIsFavorite(found);
    }, [favorites]);

    function viewProduct() {
        navigate('/product/' + data.itemURL, {
            state: { product: data }
        });
    }

    function addToCart(e) {
        // we will check if the product is already in the cart and render appropriately.
        dispatch(addCartItems([{ ...data, quantity: data.quantity || 1 }]));
        dispatch(setAlert('Item added to Cart'));
    }

    function removeFromCart() {
        dispatch(removeCartItem(data.item_code));
        dispatch(setAlert({ type: 'warning', message: 'Item removed from Cart' }));
    }

    function addToFavorite() {
        dispatch(addFavorite(data));
    }

    function removeFromFavorite() {
        dispatch(removeFavorite(data.item_code));
    }

    const percentage = (number) => {
        const fraction = Math.round((number / 500) * 100)
        return fraction > 100 ? 100 : fraction;
    }
    // console.log(data)


    const savingpercentage = data?.amount_value ? Math.round(((parseFloat(data.amount_value) - parseFloat(data.promotion_price)) / parseInt(data.amount_value)) * 100) : 0


    return (
        <div className='singleproductcard'>
            {(pathname === '/todays-deals' || showquantity) && <>
                <div className='offerbanner'>save<br />{savingpercentage == 'NaN' ? 0 : savingpercentage}% </div>
            </>}

            <div className='likebutton'>
                <IconButton
                    color="primary"
                    title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                    onClick={() => (isFavorite ? removeFromFavorite() : addToFavorite())}
                >
                    {isFavorite ? <Favorite /> : <FavoriteBorder />}
                </IconButton>
            </div>
            <p align="middle" className='wrapimage' onClick={viewProduct}>
                <img src={thumbnail} className='singleproductcardimage' />
                {thumbnail == null && <span dangerouslySetInnerHTML={{ __html: icons.sm_spinner }}></span>}
            </p>
            <div className={isCartItem ? 'productfooterincart' : 'productfooter'}>
                <div className='productname' onClick={viewProduct}>{capitalize(data.item_name)}</div>
                <div className='pricingsection'>
                    <div className='wrapprice' onClick={viewProduct}>
                        <div className='currencytext'>{webSettings.CURRENCY}</div>
                        {data.promotion_price > 0 ?
                            <div className='pricetext'>{data.promotion_price} <div className='discountprice'>{parseFloat(data.price)?.toFixed(2)}</div></div> :
                            <div className='pricetext'>{parseFloat(data.price)?.toFixed(2)}</div>}
                    </div>
                    <div className='shoppingicon'>
                        <IconButton
                            disabled={data.closing < 1 && true}
                            onClick={() => isCartItem ? removeFromCart() : addToCart()}
                            title={isCartItem ? 'Remove from cart' : 'Add to cart'}
                        >
                            {isCartItem ? <CheckCircle color='primary' /> : <ShoppingBasketOutlined />}
                        </IconButton>
                    </div>
                </div>
                {(pathname === '/todays-deals' || showquantity) && <>
                    {webSettings.ITEMS_OUTOFSTOCK_LABEL === 'Y' && <div className='unitslefttext'>{data.closing > 0 ? `${data.closing} units left` : <text className='outofstocktext'>Out of stock</text>}</div>}
                </>}
                {(pathname === '/todays-deals' || showquantity) && <>
                    {webSettings.ITEMS_OUTOFSTOCK_LABEL === 'Y' &&
                        <div className="stockprogress">
                            <div className="starslideractive" style={{
                                width: percentage(data.closing),
                                backgroundColor: percentage(data.closing) > 20 ? "orange" : "red"
                            }} />
                            <div className="starsliderinactive" />
                        </div>
                    }
                </>}
            </div>
        </div>
    );
}

export default React.memo(Product);
